import * as React from "react";
import styled from "styled-components";

interface PricingInfoPackageTrialInfoProps {}

const PricingInfoPackageTrialInfo = (props: PricingInfoPackageTrialInfoProps) => {
  return (
    <div>
      <PricingInfoPackageTrialInfoContainer>
        <FreeTrialInfoTitle>
          <strong>1 miesiąc testowy, <br/> bez zobowiązań!</strong>
        </FreeTrialInfoTitle>
        <FreeTrialInfoDescription>
          <p>Twoja księgowość online jeszcze nie była tak prosta.</p>
          <p>
            Testuj <span>bezpłatnie przez 1 miesiąc.</span>
          </p>
        </FreeTrialInfoDescription>
      </PricingInfoPackageTrialInfoContainer>
    </div>
  )
};

/** STYLES */

const PricingInfoPackageTrialInfoContainer = styled.div`
  @media (min-width : 993px) {
    margin-top: 100px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-right: 30px;
    padding-left: 30px;
  }
  @media (max-width : 993px) {
    text-align: center;
    margin-top: 60px;
    margin-bottom: 40px;
  }
`;

const FreeTrialInfoTitle = styled.h3`
  color: #424242 !important;
  display: block;
  font-size: 35px !important;
  strong {
    font-weight: bold;
  }
`;

const FreeTrialInfoDescription = styled.div`
  p {
    color: #4d4d4d;
    margin: 0;
    font-weight: 400 !important;
    font-size: 18px;
    span {
      font-weight: bold;
      color: #1976d2;
    }
  }
`;

export default PricingInfoPackageTrialInfo


// WEBPACK FOOTER //
// ./src/layouts/pricing-info-block/pricing-info-package-trial-info.tsx